import React, { Component } from 'react'
import { Layout, PageHeader } from 'antd'
import InquiriesList from '@components/InquiriesList'
import FilterBar from './FilterBar'

export default class Inquiries extends Component {
    render() {
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="פניות לקוחות"
                    subTitle="תצוגת כל הפניות של הלקוחות"
                />
                <FilterBar />
                <InquiriesList />
            </Layout>
        )
    }
}
